import React from "react";

const entityPaths = {
  lead: "c-investor",
  account: "c-vendor",
  vendor: "c-agent",
  organization: "c-firm"
};

export function getOpenInCrmHref(leadId, entityType = "lead") {
  if (!leadId) return null;
  const path = entityPaths[entityType] || entityPaths.lead;
  return `https://accounts.kore.co/crm/${path}/${leadId}`;
}

const baseStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "6px 12px",
  backgroundColor: "#ffffff",
  borderRadius: "6px",
  border: "1px solid #dadce0",
  color: "#1a73e8",
  textDecoration: "none",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: 1.2
};

const variantStyles = {
  button: baseStyle,
  compact: {
    ...baseStyle,
    padding: "4px 8px",
    fontSize: "13px"
  },
  link: {
    ...baseStyle,
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    whiteSpace: "nowrap"
  }
};

/** Same graphic as the Vendors list “Open in CRM” control (re-use for inline CRM links). */
export const OpenInCrmIcon = (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
    <polyline points="15 3 21 3 21 9"></polyline>
    <line x1="10" y1="14" x2="21" y2="3"></line>
  </svg>
);

const OpenInCrmButton = ({
  leadId,
  entityType = "lead",
  label = "Open in CRM",
  variant = "button",
  className,
  style
}) => {
  if (!leadId) {
    return null;
  }

  const href = getOpenInCrmHref(leadId, entityType);
  const variantStyle = variantStyles[variant] || baseStyle;
  if(label === "Open in CRM"){
    return (
      <a
        href={href}
        target="crm-investor"
        className={className}
        style={{
          ...variantStyle,
          ...style
        }}
      >
        {OpenInCrmIcon}
        {label}
      </a>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      className={className}
      rel="noopener noreferrer"
      style={{
        ...variantStyle,
        ...style
      }}
    >
      {OpenInCrmIcon}
      {label}
    </a>
  );
};

export default OpenInCrmButton;
